export default __webpack_public_path__ + "static/media/TableSelect_icon.86add6d6.png";